// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Tag } from 'antd';

// Misc imports
import { NDE_TYPES } from '../../constants';

const NdeTypeTag = (props) => {
  const { type, ...restProps } = props;
  const { t } = useTranslation();

  const TAG_COLORS = {
    [NDE_TYPES.PEACEFUL]: 'green',
    [NDE_TYPES.DISTRESSING]: 'red',
    [NDE_TYPES.NEUTRAL]: 'default',
    [NDE_TYPES.MIXED]: 'orange'
  };

  return type ? (
    <Tag color={TAG_COLORS[type] || 'default'} {...restProps}>
      {t(type, { context: 'nde type' })}
    </Tag>
  ) : '-';
};

NdeTypeTag.propTypes = {
  type: PropTypes.string
};

export default NdeTypeTag;
